<template>
    <div class="col-md-4">
        <div class="company-photo" v-if="fileInfo">
            <img :src="getNameOfPhoto(fileInfo.file_path)" alt="User Photo" width="115">
            <a
                href="javascript:void(0)"
                class="edit"
                @click="$refs.imageInput.click()"
            >
                <svg width="16" height="16" class="icon">
                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                </svg>
            </a>
        </div>
        <a
            href="javascript:void(0)"
            class="company-upload"
            v-else
            @click="$refs.imageInput.click()"
        >
            <img src="/img/svg/photo.svg" alt="" width="43" area-hidden="true">
            <span>Upload Photo</span>
            <small>Max 10 MB in .jpg/.png format</small>
        </a>
        <input
            type="file"
            style="display: none"
            @change="onImageSelected"
            ref="imageInput"
            accept="image/png,image/jpeg"
        >
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import AdminService from "../../services/AdminService";

export default defineComponent({
    name: "CoverUploader",
    emits: ['update-cover'],
    props: {
        componentName: String,
        file: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            selectedFile: null,
            fileInfo: this.file,
        }
    },
    watch: {
        file: {
            handler(val) {
                if (val) {
                    this.fileInfo = val;
                    this.$emit('update-cover', this.fileInfo);
                }
            },
            deep: true
        }
    },
    methods: {
        getNameOfPhoto(photo) {
            return photo ? `/uploads${photo}` : "/img/svg/avatar.svg";
        },
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        async uploadPhoto() {
            if (!this.selectedFile) {
                this.$showErrorMessage("Please select a photo");
                return;
            }

            this.$showLoadingMessage();

            const formData = new FormData();
            formData.append('file', this.selectedFile);

            const uploadMethod = this.componentName === 'category'
                ? AdminService.uploadCategoryCover
                : AdminService.uploadCompanyCover;

            try {
                const response = await uploadMethod(formData);
                this.fileInfo = response.data;
                this.$emit('update-cover', response.data);
                this.$showSuccessMessage("The photo was uploaded");
            } catch (e) {
                console.error(e);
                this.$showErrorMessage("The photo was not uploaded");
            }
        }
    }
})
</script>



<style scoped>

</style>
